module.exports = __webpack_public_path__ + "img/SILENT_A1014.c6629d8c.png";